import { Box } from "@mui/system";
import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { getAmount, getDate, getTime } from "../../redux/services/utility";
import { FaCalendarAlt, FaCar, FaClock, FaMapMarkerAlt, FaUser } from "react-icons/fa";
import PickupLocationIcon from "../../assets/Pickup@4x.png";
import Location from "../../assets/location.svg";
import Calender from "../../assets/date.svg";
import Clock from "../../assets/Sidebar (9).png";
import Profile from "../../assets/Profile.png";
import Vehicle from "../../assets/VehicleDetails.png";
import Partner from "../../assets/Partner@4x.png"

type Props = {
  bookingDetail: any;
  isBooking: boolean;
  parkingSpaceName?: any;
  customerData?: any;
  isLoggedIn?: boolean;
  parkingDetail?: any;
  values?: any;
  touched?: any;
  errors?: any;
  isRedeem?: boolean;
};

const BookingSummary = (props: Props) => {
  console.log(props.bookingDetail, props.parkingDetail.parentCompanyName, "props of payment");
  return (
    <Box>
      <div className="bg-[#F9F4EF] mb-3 p-6 h-fit rounded-xl shadow-md mt-3">
        <div className="mb-4">
            <div className="flex items-center">
              <img src={Vehicle} alt="Location" className=" mr-8 w-6 h-6" />
              <div>
                <h3 className="text-lg font-medium text-black">  {props?.parkingDetail?.vehicleDetailObj?.model}</h3>
              </div>
            </div>
            <div className="flex items-center mt-2">
              <img src={Partner} alt="Location" className=" mr-8 w-7 h-7" />
              <div>
                <h3 className="text-lg font-medium text-black">  {props.parkingDetail.parentCompanyName}</h3>
              </div>
            </div>
        </div>
        <div className="mb-4">
          <div className="flex items-center justify-between">
            {/* Pick Up Date */}
            <div className="flex items-center">
              <img src={Calender} alt="Location" className=" mr-8 w-6 h-6" />
              <div>
                <h3 className="text-lg font-medium text-black">{getDate(props?.bookingDetail?.payload?.checkinTime)}</h3>
                <p className="text-sm text-gray-500">Pick Up Date</p>
              </div>
            </div>
            {/* Divider */}
            <div className="border-l border-gray-500 mx-4 h-6"></div>
            {/* Pick Up Time */}
            <div className="flex items-center">
              <img src={Clock} alt="Location" className=" mr-8 w-6 h-6" />
              <div>
                <h3 className="text-lg font-medium text-black">{getTime(props?.bookingDetail?.payload?.checkinTime)}</h3>
                <p className="text-sm text-gray-500">Pick Up Time</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#F9F4EF] rounded-xl shadow-md p-6">
        {/* Pick Up Location */}
        <div className="flex items-start gap-4">
          <div className="flex flex-col items-center">
            <img src={PickupLocationIcon} alt="From" className=" lg:w-6 h-6 md:w-10 w-8" />
            {props?.bookingDetail?.payload?.toLocation && (
              <div className="border-l-2 mt-1 border-dashed border-[#ED1C24] h-10"></div>
            )}
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-600">Pick Up</h3>
            <p className="text-black text-sm">
              {props?.bookingDetail?.payload?.fromLocation}
            </p>
          </div>
        </div>
        {/* Drop Off Location */}
        {props?.bookingDetail?.payload?.toLocation && (
          <div className="flex items-start gap-4 mt-2">
            <img src={Location} alt="Location" className="lg:w-6 h-6 md:w-10 w-8" />
            <div>
              <h3 className="text-lg font-semibold text-gray-600">Drop Off</h3>
              <p className="text-black text-sm">
                {props?.bookingDetail?.payload?.toLocation}
              </p>
            </div>
          </div>
        )}
        {/* Traveler Details */}
        <hr className="border-t border-gray-300 my-2" />
        <div className="mt-4 flex flex-row items-center">
          <img src={Profile} alt="Location" className="w-6 h-6" />
          <div className="ml-2">
            <h3 className="flex items-center text-lg font-semibold text-gray-600">
              Travelers:&nbsp;<span>Adult {props?.bookingDetail?.tripDetails?.passengerDetails?.adults} |&nbsp;</span>
              <span>Kids {props?.bookingDetail?.tripDetails?.passengerDetails?.kids}</span>
              <p className="text-black text-sm">
                {props?.bookingDetail?.tripDetails?.fullName}
              </p>
            </h3>
            <p className="text-black text-sm">
              {props?.bookingDetail?.tripDetails?.emailId} |{' '}
              {props?.bookingDetail?.tripDetails?.contactNumber}
            </p>
          </div>


        </div>
      </div>

    </Box>


  );
};

export default BookingSummary;
